import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/file-pdf': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M369.9 97.9L286 14C277 5 264.8-0.1 252.1-0.1H48C21.5 0 0 21.5 0 48V464C0 490.5 21.5 512 48 512H336C362.5 512 384 490.5 384 464V131.9C384 119.2 378.9 106.9 369.9 97.9zM332.1 128H256V51.9L332.1 128zM48 464V48H208V152C208 165.3 218.7 176 232 176H336V464H48zM298.2 320.3C286 308.3 251.2 311.6 233.8 313.8 216.6 303.3 205.1 288.8 197 267.5 200.9 251.4 207.1 226.9 202.4 211.5 198.2 185.3 164.6 187.9 159.8 205.6 155.4 221.7 159.4 244.1 166.8 272.7 156.8 296.6 141.9 328.7 131.4 347.1 111.4 357.4 84.4 373.3 80.4 393.3 77.1 409.1 106.4 448.5 156.5 362.1 178.9 354.7 203.3 345.6 224.9 342 243.8 352.2 265.9 359 280.7 359 306.2 359 308.7 330.8 298.2 320.3zM100.1 398.1C105.2 384.4 124.6 368.6 130.5 363.1 111.5 393.4 100.1 398.8 100.1 398.1zM181.7 207.5C189.1 207.5 188.4 239.6 183.5 248.3 179.1 234.4 179.2 207.5 181.7 207.5zM157.3 344.1C167 327.2 175.3 307.1 182 289.4 190.3 304.5 200.9 316.6 212.1 324.9 191.3 329.2 173.2 338 157.3 344.1zM288.9 339.1S283.9 345.1 251.6 331.3C286.7 328.7 292.5 336.7 288.9 339.1z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/file-pdf.js
// module id = nQEE
// module chunks = 144